import { namespace } from 'wsm-tagging-utils';

const runDataAttributeDecorator = (win) => {
	namespace(win, 'DDC.tracking.adobe_launch.decorators');

	const {
		DDC: { tracking }
	} = win;

	/**
	 * The Data Attribute Decorator takes any data attributes and adds them to the eventData payload in a specific format
	 * data-tracking-current-item is turned into eventData.currentItem
	 *
	 * @param {Object} thisWin The window object
	 * @param {tracking.framework.runtime.Page} page A Page instance for page related queries
	 * @param {tracking.framework.runtime.EventHandler} delegate The EventHandler implementation to which all interface operations are delegated
	 * @constructor
	 */
	tracking.adobe_launch.decorators.DataAttributeDecorator = class extends (
		tracking.framework.runtime.EventHandlerDecorator
	) {
		constructor(thisWin, page, delegate) {
			super(thisWin, page, delegate);
			this.logCategory = 'DataAttributeDecorator';

			// Handlers needing decorator applied
			this.eventHandlers = ['handleLinkClick'];

			this.createHandlerDecorators();
		}

		// Create handler decorators from eventHandler array to add data attributes into eventData
		createHandlerDecorators() {
			this.eventHandlers.forEach((handler) => {
				this[handler] = (eventDataIn) => {
					const eventData = eventDataIn;
					if (eventData.element && eventData.element.dataset) {
						Object.entries(eventData.element.dataset).forEach(
							(attributeValuePair) => {
								[, eventData[attributeValuePair[0]]] =
									attributeValuePair;
							}
						);
					}

					this.delegate[handler](eventData);
				};
			});
		}
	};

	tracking.adobe_launch.decorators.DataAttributeDecorator.prototype.logCategory =
		'DataAttributeDecorator';
};

export default runDataAttributeDecorator;
